const isProdDataInLocal = () => {
  const {
    PANDAPI_URL,
    API_URL,
    WS_URL,
    HASHI_URL,
    HASHI_WS,
    CONTROL_URL,
    CONTROLE_URL,
    PANDALOG_URL,
    SOL_URL,
    RATCHET_URL
  } = process.env;
  return (
    [
      PANDAPI_URL,
      API_URL,
      WS_URL,
      HASHI_URL,
      HASHI_WS,
      CONTROL_URL,
      CONTROLE_URL,
      PANDALOG_URL,
      SOL_URL,
      RATCHET_URL
    ].some(url => url && !url.includes('.dev.')) && window.location.hostname === 'localhost'
  );
};

export { isProdDataInLocal };
